module.exports = __webpack_public_path__ + "d8c350e289714ee7c312bdb5a66835.png";